// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function Button(theme) {
    const disabledStyle = {
        '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[200]
        }
    };

    return {
        MuiButton: {
            defaultProps: {
                disableElevation: true
            },
            styleOverrides: {
                root: {
                    fontWeight: 700,
                    paddingLeft: theme.spacing(4),
                    paddingRight: theme.spacing(4),
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                },
              sizeSmall: {
                  paddingTop: theme.spacing(0.2),
                paddingBottom: theme.spacing(0.2),
              },
                contained: {
                    ...disabledStyle,
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.15s ease-in-out',
                    transform: 'scale(1)',
                    '&:hover': {
                        transform: 'scale(1.05) translateY(-2px)',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
                    },
                    '&:active': {
                        transform: 'scale(0.98) translateY(0px)',
                        transition: 'all 0.1s ease'
                    }
                },
                outlined: {
                    ...disabledStyle
                },
                text: {
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                }
            }
        }
    };
}
